export const DATA = {
  BEGINNER: "I'm a beginner",
  AVERAGE: "I have some experience",
  ADVANCED: "I am proficient",
};
